import { ActorBasicData } from "src/contexts/_shared/domain/ActorBasicData";
import { ActorIdentityRepresentative } from "src/contexts/documentationArea/domain/ActorIdentityRepresentative";
import { IdNumberCountries } from "src/contexts/documentationArea/domain/IdNumberCountries";
import { IdNumberTypes } from "src/contexts/documentationArea/domain/IdNumberTypes";

interface BuildActorBasicDataParams {
  representative: ActorIdentityRepresentative | undefined;
  companyName: string;
  idNumber: string;
  idNumberType: IdNumberTypes;
  idNumberCountry: IdNumberCountries;
  representedEntityIdNumber: string;
  representedEntityIdNumberType: IdNumberTypes;
  representedEntityIdNumberCountry: IdNumberCountries;
  representedEntityRelationType: string;
}

export const buildActorBasicData = ({
  representative,
  companyName,
  idNumber,
  idNumberType,
  idNumberCountry,
  representedEntityIdNumber,
  representedEntityIdNumberCountry,
  representedEntityIdNumberType,
  representedEntityRelationType,
}: BuildActorBasicDataParams): ActorBasicData => ({
  representative: {
    name: representative?.getName() ?? "",
    firstSurname: representative?.getFirstSurname() ?? "",
    secondSurname: representative?.getSecondSurname() ?? undefined,
    idNumber: {
      number: idNumber.trim(),
      type: idNumberType,
      country: idNumberCountry,
    },
  },
  representedEntity: {
    legalName: companyName.trim(),
    individualRelationType: representedEntityRelationType,
    idNumber: {
      number: representedEntityIdNumber.trim(),
      type: representedEntityIdNumberType,
      country: representedEntityIdNumberCountry,
    },
  },
});
